// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"error404_errorPage__3pcox","errorPageTitle":"error404_errorPageTitle__2x4DA"};